import React from "react";
import { Link } from "react-router-dom";



function Footer() {
  return (
    <footer>
      <div className="footer-top-area footer-bg">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-3">
              <div className="footer-widget">
                <div className="f-logo">
                  <Link to="/">
                    <img src="img/logo/logo.png" alt="" />
                  </Link>
                </div>
                <div className="footer-text">
                  <p>
                    Si tienes preguntas, inquietudes o simplemente deseas saber
                    más sobre nuestros servicios y cómo puedes ayudar, ¡no dudes
                    en contactarnos!
                  </p>
                </div>
                <div className="footer-contact">
                  <div className="icon">
                    <i className="fas fa-headphones" />
                  </div>
                  <div className="content">
                    <h4 className="title">
                      <a href="mailto:support@galileopethouse.com">
                        Galileo Support
                      </a>
                    </h4>
                    <span>Escríbenos</span>
                  </div>
                </div>
                <div className="footer-social">
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.facebook.com/profile.php?id=61561061009696"
                        rel="noreferrer">
                        <i className="fab fa-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/galileopethouse/"
                        rel="noreferrer">
                        <i className="fab fa-instagram" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/company/galileo-pet-house"
                        rel="noreferrer">
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-2">
              <div className="footer-widget">
                <h4 className="fw-title">Nuestras Políticas</h4>
                <div className="fw-link">
                  <ul>
                    <li>
                      <Link to="/">Política de privacidad</Link>
                    </li>
                    <li>
                      <Link to="/">Términos y condiciones</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-2">
              <div className="footer-widget">
                <h4 className="fw-title">Nuestros Servicios</h4>
                <div className="fw-link">
                  <ul>
                    <li>
                      <Link to="/">Servicios en la App</Link>
                    </li>
                    <li>
                      <Link to="/">Nuestra tienda</Link>
                    </li>
                    <li>
                      <Link to="/">Contáctanos</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="footer-widget">
                <h4 className="fw-title">Instagram</h4>
                <div className="fw-insta">
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/galileopethouse/"
                        rel="noreferrer">
                        <img src="img/images/insta_img01.png" alt="" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/galileopethouse/"
                        rel="noreferrer">
                        <img src="img/images/insta_img02.png" alt="" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/galileopethouse/"
                        rel="noreferrer">
                        <img src="img/images/insta_img03.png" alt="" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/galileopethouse/"
                        rel="noreferrer">
                        <img src="img/images/insta_img04.png" alt="" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/galileopethouse/"
                        rel="noreferrer">
                        <img src="img/images/insta_img05.png" alt="" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/galileopethouse/"
                        rel="noreferrer">
                        <img src="img/images/insta_img06.png" alt="" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-shape">
          <img src="img/images/footer_shape01.png" alt="" />
        </div>
        <div className="footer-shape shape-two">
          <img src="img/images/footer_shape02.png" alt="" />
        </div>
      </div>
      <div className="copyright-area">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="copyright-text">
                <p>
                  Copyright © {new Date().getFullYear()} GalileoPetHouse. Todos
                  los derechos reservados.
                </p>
              </div>
            </div>
            <div className="col-md-4 d-none d-md-block">
              {/* <div className="footer-lang">
                <div className="dropdown">
                  <button
                    className="dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton2"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <img src="img/icon/united-states.png" alt="" /> English
                  </button>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton2">
                    <Link className="dropdown-item" to="/">
                      <img src="img/icon/russia.png" alt="" />
                      Russia
                    </Link>
                    <Link className="dropdown-item" to="/">
                      <img src="img/icon//thailand.png" alt="" />
                      Thailand
                    </Link>
                    <Link className="dropdown-item" to="/">
                      <img src="img/icon/india.png" alt="" />
                      India
                    </Link>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
